import React, { Component } from 'react'
import { Grid, Row, Col, Glyphicon } from 'react-bootstrap'
import { connect } from 'react-redux'
import { fetchCollection } from '../../common/redux/collectionActions'
import RentalFilter from './RentalFilter'
import RentalRowItem from './RentalRowItem'
import { stringMatchInsensitive, translate } from '../../common/utils'
import moment from 'moment'
import MyLoader from '../../common/components/MyLoader'

const rentalTranslations = {
    sendBack: 'en retur',
    change: 'ett byte',
    collect: 'en uthämtning',
    asap: 'Express',
    suitable: 'Standard'
}

class Rental extends Component {
    constructor(p) {
        super(p)

        this.state = {
            startDate: moment().add(-6, 'months'),
            endDate: moment(),
            filter: null
        }

        this.updatedFilter = this.updatedFilter.bind(this)
        this.filter = this.filter.bind(this)
        this.applyTextFilter = this.applyTextFilter.bind(this)
        this.changeDate = this.changeDate.bind(this)
    }

    componentWillMount() {
        if (!this.props.admin) this.props.fetchCollection("admin")
        if (!this.props.rentals) this.props.fetchCollection("rentals", { startDate: this.state.startDate.toISOString(), endDate: this.state.endDate.toISOString() })
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    updatedFilter(filter) {
        this.setState({ filter })
    }

    changeDate(e, type) {
        this.setState({ [`${type}Date`]: moment(e) }, () => this.props.fetchCollection("rentals", { startDate: this.state.startDate.toISOString(), endDate: this.state.endDate.toISOString() }))
    }

    exportCSV = (rentals) => {
        if (!rentals || !rentals.length) return ''

        try {
            var csv = [`Avsändare,Avsändarens företag,Projektets Företagsnamn,Typ,Mottagarföretag,Avsändarplats,Projektnummer,Kommentar,Individer,Skapad`.split(',')]

            for (var r of rentals) {
                csv.push([
                    `${r.customer.name} ${r.customer.surname}`,
                    `${r.userCompanyName || 'Okänt företag'}`,
                    `${r.lock.custom_name.split(' ')[0]}`,
                    `'${rentalTranslations[r.SelectAction]}`,
                    `${r.rentalCompany.name}`,
                    `${r.lock.address.street}, ${r.lock.address.zip} ${r.lock.address.city}`,
                    `${r.projectNumber}`,
                    `${r.comment}`,
                    `${r.deviceSerialNumbers.join(', ')}`,
                    `${moment(new Date(parseInt(r._id.substring(0, 8), 16) * 1000)).format('YYYY/MM/DD - HH:mm')}`
                ])
            }

            return csv
        } catch (e) {
            console.log(e)
        }
    }

    filter(rentals) {
        const f = this.state.filter
        if (!f) return rentals

        const locksKeysLength = Object.keys(f.selectedLocks).length
        const customersKeysLength = Object.keys(f.selectedCustomers).length
        const vendorsKeysLength = Object.keys(f.selectedRentalCompanys).length

        if (!locksKeysLength && !customersKeysLength && !vendorsKeysLength) {
            return rentals
        }

        return rentals.filter(r => {
            if (locksKeysLength && !vendorsKeysLength && !customersKeysLength) {
                if (f.selectedLocks[r.lock._id] != undefined) return true
            }

            if (!locksKeysLength && vendorsKeysLength && !customersKeysLength) {
                if (f.selectedRentalCompanys[r.rentalCompany._id] != undefined) return true
            }

            if (!locksKeysLength && !vendorsKeysLength && customersKeysLength) {
                if (f.selectedCustomers[r.customer._id] != undefined) return true
            }

            if (locksKeysLength && vendorsKeysLength && !customersKeysLength) {
                if (f.selectedLocks[r.lock._id] != undefined && f.selectedRentalCompanys[r.rentalCompany._id]) return true
            }

            if (!locksKeysLength && vendorsKeysLength && customersKeysLength) {
                if (f.selectedRentalCompanys[r.rentalCompany._id] && f.selectedCustomers[r.customer._id]) return true
            }

            if (locksKeysLength && !vendorsKeysLength && customersKeysLength) {
                if (f.selectedLocks[r.lock._id] && f.selectedCustomers[r.customer._id]) return true
            }

            if (locksKeysLength && vendorsKeysLength && customersKeysLength) {
                if (f.selectedLocks[r.lock._id] && f.selectedRentalCompanys[r.rentalCompany._id] && f.selectedCustomers[r.customer._id]) return true
            }

            return false
        })
    }

    applyTextFilter(rentals) {
        const f = this.state.filter
        if (!f || !f.searchString || !f.searchString.length) return rentals

        return rentals.filter(r => {
            if (stringMatchInsensitive(`${r.lock.custom_name}`, f.searchString)) return true
            if (stringMatchInsensitive(`${r.lock.address.street}`, f.searchString)) return true
            if (stringMatchInsensitive(`${r.customer.name} ${r.customer.surname}`, f.searchString)) return true
            if (stringMatchInsensitive(`${r.rentalCompany.name}`, f.searchString)) return true

            if (r.deviceSerialNumbers.some(nr => stringMatchInsensitive(nr, f.searchString))) return true
            if (r.photoKeys.some(key => stringMatchInsensitive(key, f.searchString))) return true

            return false
        })
    }

    render() {
        const rentals = this.props.rentals || []

        var filteredRentals = this.applyTextFilter(this.filter(rentals))

        return (
            <div>
                <MyLoader />

                <RentalFilter
                    changeDate={this.changeDate} initialValues={{ startDate: this.state.startDate, endDate: this.state.endDate }} rentals={rentals} updateFilter={this.updatedFilter}
                    csvData={this.exportCSV(rentals)}
                />

                <hr />

                <Grid fluid style={{ margin: 'auto', width: '85%' }}>
                    {!rentals.length ? <Row><Col xs={12} md={12} lg={12} style={{ textAlign: 'center' }}><p>Inga registrerade ordrar</p></Col></Row> : null}
                    {filteredRentals.map(item => {
                        return (<RentalRowItem key={item._id} item={item} translations={rentalTranslations} />)
                    })}
                </Grid>
            </div>
        )
    }
}

const mapProps = state => {
    return {
        admin: state.collectionData.admin,
        rentals: state.collectionData.rentals
    }
}

const mapDispatch = dispatch => {
    return {
        fetchCollection: (...args) => dispatch(fetchCollection(...args))
    }
}

export default connect(mapProps, mapDispatch)(Rental)